/** Maximum stored operator-note length for a managed-vpatch hold. */
export const MANAGED_VPATCH_HOLD_NOTE_MAX_LENGTH = 256;

/** Console request shape: creating or updating a hold requires a note; release does not. */
export type ManagedVpatchHoldInput =
  | { held: true; intent: 'create' | 'update'; note: string }
  | { held: false; intent?: never; note?: never };
